import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@material-ui/core'

import { TrainedUsersByDepartment, UsersByConclusion } from './components'

import constants from 'constants/index'

const DashboardTraining = ({ trainingStats }) => {
  const { training: trainingIds } = constants.myLgpd.GRAPH_IDS

  const trainings = trainingStats?.trainings || []

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h4" color="primary">
          Treinamentos
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <TrainedUsersByDepartment
              trainings={trainings}
              id={trainingIds.trainedUsersByDepartment}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <UsersByConclusion
              trainings={trainings}
              id={trainingIds.usersByConclusion}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

DashboardTraining.propTypes = {
  trainingStats: PropTypes.object.isRequired,
}

export default DashboardTraining
